import {Observable, Subject} from 'rxjs';

import IErrorsPayload from '../Interfaces/IErrorsPayload';

const subscribeToPlaybackInterruptedConnectionLost = (
    playbackInterruptedConnectionLost$: Observable<IErrorsPayload>,
    consumerError$: Subject<IErrorsPayload>
) => playbackInterruptedConnectionLost$
    .subscribe(error => consumerError$.next(error));

export default subscribeToPlaybackInterruptedConnectionLost;
